export const TYPE_MARKDOWN = 'MARKDOWN'
export const TYPE_VOTES = 'VOTES'
export const VOTING_STATUS_ONGOING = 'VOTING_STATUS_ONGOING'
export const VOTING_STATUS_REJECTED = 'VOTING_STATUS_REJECTED'
export const VOTING_STATUS_ACCEPTED = 'VOTING_STATUS_ACCEPTED'
export const VOTING_STATUS_PENDING_ENACTMENT = 'VOTING_STATUS_PENDING_ENACTMENT'
export const VOTING_STATUS_ENACTED = 'VOTING_STATUS_ENACTED'
export const VOTING_STATUS = {
  VOTING_STATUS_ACCEPTED: 'Passed',
  VOTING_STATUS_ENACTED: 'Passed',
  VOTING_STATUS_ONGOING: '',
  VOTING_STATUS_PENDING_ENACTMENT: 'Passed',
  VOTING_STATUS_REJECTED: 'Rejected',
}
